import React from 'react';
import BraceletCustomizer from './pages/BraceletCustomizer';

function App() {
  return <BraceletCustomizer />;
}

export default App;